import { render } from "./FooterRightsComponent.vue?vue&type=template&id=1a00bdea&scoped=true"
import script from "./FooterRightsComponent.vue?vue&type=script&lang=js"
export * from "./FooterRightsComponent.vue?vue&type=script&lang=js"

import "./FooterRightsComponent.vue?vue&type=style&index=0&id=1a00bdea&lang=scss&scoped=true"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a00bdea"]])

export default __exports__